export enum CollectionStatus {
	PENDING = "PENDING",
	OFFCHAIN = "OFFCHAIN",
	ONCHAIN = "ONCHAIN",
	PAUSED = "PAUSED",
}
